
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function EventPromo() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="pt-16 pb-10 sm:py-24 bg-gradient-to-br from-[#0A0A0A] via-[#0F0F0F] to-[#0A0A0A] relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#14B8A6]/5 via-transparent to-transparent"></div>

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8">
        {/* 모바일 EVENT 타이틀 */}
        <div className="sm:hidden text-center mb-4">
          <span className="text-[32px] font-black bg-gradient-to-r from-[#14B8A6] to-[#0D9488] bg-clip-text text-transparent tracking-wider">EVENT</span>
        </div>

        <Link 
          to="/event"
          className={`group cursor-pointer bg-gradient-to-br from-[#14B8A6]/10 via-[#0D9488]/5 to-[#14B8A6]/10 border-2 border-[#14B8A6]/30 rounded-2xl sm:rounded-[40px] p-4 sm:p-16 hover:border-[#14B8A6]/60 hover:shadow-2xl hover:shadow-[#14B8A6]/20 transition-all duration-700 transform hover:scale-[1.02] relative overflow-hidden block ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}
        >
          {/* 모바일 레이아웃 */}
          <div className="sm:hidden">
            <div className="flex items-center gap-3 mb-3">
              <div className="flex-1">
                <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] rounded-full mb-2">
                  <i className="ri-fire-line text-white text-[12px]"></i>
                  <span className="text-[10px] font-bold text-white">🔥 히어로를 찾습니다!</span>
                </div>
                <h2 className="text-[20px] font-black text-white leading-tight">
                  숙제 완수하고
                </h2>
                <h2 className="text-[24px] font-black bg-gradient-to-r from-[#14B8A6] to-[#0D9488] bg-clip-text text-transparent leading-tight">
                  ₩20,000 환급!
                </h2>
              </div>
              <div className="bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border border-[#14B8A6]/30 rounded-xl p-3 text-center">
                <div className="text-[28px] font-black bg-gradient-to-r from-[#14B8A6] to-[#0D9488] bg-clip-text text-transparent leading-none">
                  10%
                </div>
                <p className="text-[9px] text-gray-400">매달 추첨</p>
              </div>
            </div>
            
            <div className="flex items-center justify-between gap-2">
              <div className="flex-1 space-y-1">
                <div className="flex items-center gap-1.5">
                  <div className="w-4 h-4 rounded-full bg-[#14B8A6]/20 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#14B8A6] text-[10px]"></i>
                  </div>
                  <p className="text-[10px] text-gray-300">Personal 플랜 구매</p>
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-4 h-4 rounded-full bg-[#14B8A6]/20 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#14B8A6] text-[10px]"></i>
                  </div>
                  <p className="text-[10px] text-gray-300">SNS 인증 시 추첨</p>
                </div>
              </div>
              <span className="px-4 py-2 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] text-white text-[11px] font-bold rounded-full whitespace-nowrap flex items-center gap-1">
                <span>자세히</span>
                <i className="ri-arrow-right-line text-[12px]"></i>
              </span>
            </div>
          </div>

          {/* 데스크톱 레이아웃 */}
          <div className="hidden sm:grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center relative z-10">
            <div className="space-y-6 sm:space-y-8 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] rounded-full">
                <i className="ri-fire-line text-white text-[16px]"></i>
                <span className="text-[13px] sm:text-[14px] font-bold text-white tracking-wide">🔥 히어로를 찾습니다!</span>
              </div>

              <div className="space-y-3 sm:space-y-4">
                <h2 className="text-[36px] sm:text-[48px] lg:text-[56px] font-black text-white leading-[1.1] tracking-tight">
                  숙제 완수하고
                </h2>
                <h2 className="text-[40px] sm:text-[52px] lg:text-[64px] font-black bg-gradient-to-r from-[#14B8A6] via-[#0D9488] to-[#14B8A6] bg-clip-text text-transparent leading-[1.1] tracking-tight">
                  ₩20,000 환급!
                </h2>
                <p className="text-[14px] sm:text-[16px] text-gray-400 pt-1">당신이 바로 <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent font-bold">강한 일본어</span>의 히어로!</p>
              </div>

              <div className="space-y-4 pt-2">
                <div className="flex items-start gap-3 justify-center lg:justify-start">
                  <div className="w-6 h-6 rounded-full bg-[#14B8A6]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#14B8A6] text-[14px]"></i>
                  </div>
                  <p className="text-[15px] sm:text-[17px] text-gray-300 leading-relaxed text-left">
                    <strong className="text-white">Personal 플랜</strong> 구매 후 숙제 완수
                  </p>
                </div>
                <div className="flex items-start gap-3 justify-center lg:justify-start">
                  <div className="w-6 h-6 rounded-full bg-[#14B8A6]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#14B8A6] text-[14px]"></i>
                  </div>
                  <p className="text-[15px] sm:text-[17px] text-gray-300 leading-relaxed text-left">
                    SNS에 인증하면 <strong className="text-white">매달 10% 추첨</strong>
                  </p>
                </div>
                <div className="flex items-start gap-3 justify-center lg:justify-start">
                  <div className="w-6 h-6 rounded-full bg-[#14B8A6]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#14B8A6] text-[14px]"></i>
                  </div>
                  <p className="text-[15px] sm:text-[17px] text-gray-300 leading-relaxed text-left">
                    당첨되면 <strong className="text-[#14B8A6]">₩20,000 환급</strong>
                  </p>
                </div>
              </div>

              <div className="pt-4 sm:pt-6 flex justify-center lg:justify-start">
                <span className="group/btn px-8 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] text-white text-[15px] sm:text-[17px] font-bold rounded-full hover:shadow-xl hover:shadow-[#14B8A6]/30 transition-all duration-300 transform hover:scale-105 flex items-center gap-3 whitespace-nowrap">
                  <span>이벤트 자세히 보기</span>
                  <i className="ri-arrow-right-line text-[18px] group-hover/btn:translate-x-1 transition-transform duration-300"></i>
                </span>
              </div>
            </div>

            <div className="relative mt-8 lg:mt-0">
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-[#14B8A6]/20 to-[#0D9488]/20 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-[#0D9488]/20 to-[#14B8A6]/20 rounded-full blur-3xl"></div>
              
              <div className="relative bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border border-[#14B8A6]/30 rounded-2xl sm:rounded-3xl p-8 sm:p-12 group-hover:border-[#14B8A6]/50 transition-all duration-500">
                <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#14B8A6] to-[#0D9488] rounded-bl-[100px] flex items-start justify-end p-4">
                  <i className="ri-gift-2-fill text-white text-[28px]"></i>
                </div>

                <div className="space-y-6 sm:space-y-8 pt-8">
                  <div className="text-center">
                    <div className="text-[60px] sm:text-[80px] font-black bg-gradient-to-r from-[#14B8A6] to-[#0D9488] bg-clip-text text-transparent leading-none mb-2">
                      10%
                    </div>
                    <p className="text-[14px] sm:text-[15px] text-gray-400">매달 완수자 중 추첨</p>
                  </div>

                  <div className="h-px bg-gradient-to-r from-transparent via-[#14B8A6]/30 to-transparent"></div>

                  <div className="text-center">
                    <div className="text-[48px] sm:text-[64px] font-black text-white leading-none mb-2">
                      ₩20,000
                    </div>
                    <p className="text-[14px] sm:text-[15px] text-gray-400">환급 금액</p>
                  </div>

                  <div className="bg-gradient-to-r from-[#14B8A6]/10 to-[#0D9488]/10 border border-[#14B8A6]/20 rounded-xl p-4 sm:p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <i className="ri-calendar-check-line text-[#14B8A6] text-[20px]"></i>
                      <span className="text-[13px] sm:text-[14px] font-semibold text-white">참여 방법</span>
                    </div>
                    <div className="space-y-2 text-[12px] sm:text-[13px] text-gray-400">
                      <p>1. Personal 플랜 구매</p>
                      <p>2. 매일 숙제 완수</p>
                      <p>3. SNS 인증 게시</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
